import Button from '@app/components/Button/Button'
import Dialog from '@app/components/Dialog/Dialog'
import React, { FC, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import Spinner from '@app/components/Spinner'
import S from './styles'

interface ConfirmDialogProps {
  show?: boolean
  accountHolder: string
  iban: string
  isSubmitting?: boolean
  onExit?: () => void
  onSubmit?: () => void
}

const ConfirmDialog: FC<ConfirmDialogProps> = ({
  show = false,
  accountHolder,
  iban,
  isSubmitting = false,
  onExit,
  onSubmit,
}) => {
  const formattedIban = useMemo(() => iban.replace(/(.{4})/g, '$1 '), [iban])

  return (
    <Dialog show={show} onExit={onExit}>
      <S.Wrapper>
        <FormattedMessage id="quiz_payment_page.content.confirmation_dialog.title" tagName="h3" />
        <FormattedMessage id="quiz_payment_page.content.confirmation_dialog.intro" tagName="p" />
        <S.Content>
          <div>
            <FormattedMessage id="static.page.order.account_label" tagName="p" />
            <p>{accountHolder}</p>
          </div>
          <div>
            <FormattedMessage id="static.page.order.iban_label" tagName="p" />
            <p>{formattedIban}</p>
          </div>
        </S.Content>
        <S.Actions>
          <Button color="secondary" onClick={onExit}>
            <FormattedMessage id="quiz_payment_page.content.confirmation_dialog.cancel_button" />
          </Button>
          <Button onClick={onSubmit} disabled={isSubmitting}>
            {isSubmitting ? (
              <Spinner />
            ) : (
              <FormattedMessage id="quiz_payment_page.content.confirmation_dialog.confirm_button" />
            )}
          </Button>
        </S.Actions>
      </S.Wrapper>
    </Dialog>
  )
}

export default ConfirmDialog
